import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Button, Dropdown } from 'yankees-react-utils';

const StyledFilters = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: 10px;
`;
const StyledFiltersLabel = styled.div`
    font-size: 12px;
    font-weight: bold;
    margin-top: auto;
    margin-bottom: auto;
    padding: 0 10px;
`;
const StyledFiltersButton = styled(Button)`
&&{
    width: 75px;
    margin-left: 10px;
}
`;

const CatcherStrengthsFilters = ({ startYearOptions, endYearOptions, levelOptions, startYear, endYear, level, onSubmit }) => {
    const { t: translate } = useTranslation();
    const [filters, setFilters] = useState({ startYear: null, endYear: null, level: null });

    return (
        <StyledFilters>
            <StyledFiltersLabel>{translate('sections.reports.catcher.throwing.years')}:</StyledFiltersLabel>
            <Dropdown
                options={startYearOptions}
                value={filters.startYear || startYear}
                onSelect={(value) => setFilters({ ...filters, startYear: value })}
            />
            <StyledFiltersLabel>{translate('common.to')}</StyledFiltersLabel>
            <Dropdown
                options={endYearOptions}
                value={filters.endYear || endYear}
                onSelect={(value) => setFilters({ ...filters, endYear: value })}
            />
            <StyledFiltersLabel>{translate('baseball.level_one')}:</StyledFiltersLabel>
            <Dropdown
                options={levelOptions}
                value={filters.level || level}
                onSelect={(value) => setFilters({ ...filters, level: value })}
            />
            <StyledFiltersButton variant="primary" onClick={() => onSubmit(filters)}>{translate('common.go')}</StyledFiltersButton>
        </StyledFilters>
    );
};

CatcherStrengthsFilters.propTypes = {
    startYearOptions: PropTypes.arrayOf(PropTypes.shape(
        {
            id: PropTypes.number,
            name: PropTypes.number,
        },
    )).isRequired,
    startYear: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.number,
    }).isRequired,
    endYearOptions: PropTypes.arrayOf(PropTypes.shape(
        {
            id: PropTypes.number,
            name: PropTypes.number,
        },
    )).isRequired,
    endYear: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.number,
    }).isRequired,
    levelOptions: PropTypes.arrayOf(PropTypes.shape(
        {
            id: PropTypes.number,
            name: PropTypes.string,
        },
    )).isRequired,
    level: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
    }).isRequired,
    onSubmit: PropTypes.func.isRequired,
};

export default CatcherStrengthsFilters;
